export default __webpack_public_path__ + "static/media/2022 (2).671c12dd.jpg";